<div class="widget__wrap">
  <div class="widget" id="news-widget">
    <h2 class="widget__header">
      <span class="widget__header__title"><i class="widget__header__icon ico-angle-down"></i>Úvodní obrázky</span>
      <span class="widget__header__tools"><a class="cta cta--small cta--green" [routerLink]="['slides/add']"><span class="cta__light">Přidat</span>      snímek <i class="ico-plus"></i></a>
      </span>
    </h2>
    <div class="widget__content">
      <swb-slide-list></swb-slide-list>
    </div>
  </div>
</div>